import AbstractProductType from './AbstractProductType'
import { ProductTypeFormat } from './types'

export default class ValetUncoveredOversized extends AbstractProductType {

  name = 'valet_uncovered_oversized'
  title = 'Valet Uncovered Oversized'

  oversized = true
  valet = true
  format = ProductTypeFormat.Uncovered

}
